import React from 'react';
import Modal from 'react-modal';
import '../../styles/CustomModal.css';
import 'react-responsive-modal/styles.css';
import styled from 'styled-components';

interface ConfirmModalProps {
  isOpen: boolean;
  title: string;
  onCancelText: string;
  onConfirmText: string;
  onCancel: () => void;
  onConfirm: () => void;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  isOpen,
  onCancel,
  onConfirm,
  title,
  onCancelText,
  onConfirmText,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onCancel}
      className="confirmModal modal-content"
      closeTimeoutMS={100}
      ariaHideApp={false}>
      <Style>
        <div className="modal">
          <div className="modal_header">
            <h4>{title}</h4>
          </div>
          <div className="modal_footer">
            <button onClick={onCancel} className="cancel">
              {onCancelText}
            </button>
            <button onClick={() => onConfirm()} className="confirm">
              {onConfirmText}
            </button>
          </div>
        </div>
      </Style>
    </Modal>
  );
};
export default ConfirmModal;

const Style = styled.div`
  .modal {
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .modal_header {
    padding-top: 4%;
    h4 {
      font-weight: 500;
      color: #555555;
      line-height: 32px;
      white-space: pre-line;
    }
  }

  .modal_footer {
    padding: 0 4%;
    width: 100%;
    display: flex;
    align-items: center;
    gap: 20px;
  }
  button {
    flex: 1;
    padding: 8px 0;
    border-radius: 10px;
    font-size: 18px;
    line-height: 36px;
    font-weight: 500;
  }
  button.cancel {
    background: #ffffff;
    border: 1px solid #cecece;
    color: #555555;
  }
  button.confirm {
    background: #4dd2ae;
    border: 1px solid #4dd2ae;
    color: #ffffff;
  }

  @media (max-width: 600px) {
    .modal_header {
      h4 {
        font-size: 16px;
        line-height: 28px;
      }
    }
    .modal_footer {
      gap: 10px;
    }
    button {
      font-size: 16px;
      padding: 6px 0;
    }
  }
`;
